import Vuetify from 'vuetify';
import VueProgressBar from 'vue-progressbar';
import vuetifyOptions from './options/vuetify';
import progressBarOptions from './options/progressBar';
import './options/vueMoment';

import { use } from '../framework';

const VueMoment = require('vue-moment');

export default {
  install(Vue) {
    use(Vue, [
      [Vuetify, vuetifyOptions],
      [VueProgressBar, progressBarOptions],
      [VueMoment, {
        timezone: 'Asia/Taipei',
      }],
    ]);
  },
};



// WEBPACK FOOTER //
// ./src/plugins/index.js